import { LayoutGrid, GalleryHorizontal, Rows3 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const VIEW_OPTIONS = [
  {
    id: "grid",
    label: "Grid",
    icon: LayoutGrid,
    blurb: "A calm, editorial card grid. Best for browsing.",
  },
  {
    id: "carousel",
    label: "Carousel",
    icon: GalleryHorizontal,
    blurb: "Horizontal reels per category. Best for discovering.",
  },
  {
    id: "list",
    label: "List",
    icon: Rows3,
    blurb: "Dense rows with all the details. Best for skimming.",
  },
];

export default function LibraryViewPicker({ open, onPick }) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="sm:max-w-lg"
        data-testid="library-view-picker"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <span className="eyebrow">One quick choice</span>
          <DialogTitle className="font-serif text-3xl leading-tight text-stone-900">
            How do you want to see the library?
          </DialogTitle>
          <DialogDescription className="text-sm text-stone-500">
            Pick a default. You can switch any time from the toggle at the top.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-2">
          {VIEW_OPTIONS.map(({ id, label, icon: Icon, blurb }) => (
            <button
              key={id}
              onClick={() => onPick(id)}
              className="text-left card-editorial p-4 hover:-translate-y-0.5 hover:border-terracotta transition-all"
              data-testid={`library-view-pick-${id}`}
            >
              <span className="w-10 h-10 rounded-full bg-terracotta/10 text-terracotta flex items-center justify-center">
                <Icon size={18} />
              </span>
              <p className="font-serif text-xl text-stone-900 mt-3">{label}</p>
              <p className="text-xs text-stone-500 mt-1 leading-relaxed">{blurb}</p>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
